export type UpdateTicketRequest = {
  evntGrpTypeCd?: string;
  tcktId: string;
  teamCd?: string;
  dfnSetVerNum?: string;
  ifReqId?: string;
  dueDate?: string;
  cmnt?: string;
  desc?: string;
  updateDateTime?: string;
  preProcessParams?: Object;
  postProcessParams?: Object;
};
